const SPECIALISATIONS = [
  { icon: 'fa-route', label: 'Automatisch trace' },
  { icon: 'fa-bolt', label: 'Clash detectie' },
  { icon: 'fa-location-dot', label: 'Potentiële boorlocaties' },
  { icon: 'fa-file-lines', label: 'Omgevingsanalyse Rapportages' },
  { icon: 'fa-pen-ruler', label: 'Detail Engineering' },
  { icon: 'fa-database', label: 'Data Integratie' },
];
function HomeIntroSection() {
  return (
    <section className="c-home" id="over-sate">
      <div className="container-1280 container-1280--flush">
        <div className="c-home__group">
          <div className="c-home__themes">
            <div className="c-home__title">
              <h2 className="c-home__heading c-home__heading--sm">Gespecialiseerd in</h2>
            </div>
            <div className="c-themes">
              <ul className="c-themes__list">
                {SPECIALISATIONS.map((item) => (
                  <li key={item.label} className="c-themes__item">
                    <div className="c-themes__link">
                      <div className="c-themes__theme" aria-hidden="true">
                        <i className={`fas ${item.icon}`} />
                      </div>
                      <div className="c-themes__text">
                        <span className="c-themes__label">{item.label}</span>
                      </div>
                      <div className="c-themes__icon" aria-hidden="true">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5 12H19M19 12L13 6M19 12L13 18"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="c-home__introduce">
            <div className="c-home__title">
              <h2 className="c-home__heading">Welkom bij SATE</h2>
            </div>
            <div className="c-home__text">
              <p>
                SATE (Smart Automatisch Trace Engineering) is een door Van Gelder ontwikkelde tool die engineers
                ondersteunt bij het snel ontwerpen van kabel- en leidingtracés. Het doel van de tool is om in korte
                tijd een betrouwbaar schetsontwerp (SO) te genereren op basis van openbare data, KLIC-informatie en
                vooraf ingestelde projectvoorwaarden.
              </p>
              <p>
                Een belangrijk voordeel van SATE is dat de gegenereerde tracés achteraf bewerkt kunnen worden.
                Engineers kunnen het tracé aanpassen, waarna opnieuw clash-analyses, kostenberekeningen en
                rapportages uitgevoerd kunnen worden. Hierdoor blijft de rapportage altijd aansluiten bij het
                actuele ontwerp.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="c-home__half" aria-hidden="true" />
    </section>
  );
}

export default HomeIntroSection;
